<template>
    <div>
        <br/>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <button type="button" class="btn btn-warning mr-2"
                            @click="getSettingFix">
                        <icon name="plus"></icon>
                        ตั้งค่า fix
                    </button>
                    <button type="button" class="btn btn-primary mr-2"
                            @click="showFilterTranModal">
                        <icon name="print"></icon>
                        พิมพ์ค่าเที่ยวลูกค้ารายย่อย
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="showFilterTripModal">
                        <icon name="print"></icon>
                        พิมพ์ค่าขนส่งลูกค้ารายย่อย
                    </button>
                </form>
            </div>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead>
                <tr>
                    <th>ชื่อลูกค้าหลัก</th>
                    <th>ชื่อลูกค้าย่อย</th>
                    <th>ที่อยู่</th>
                    <th>เบอร์โทรศัพท์</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in customerOtherList">
                    <td>
                        <template v-if="data.customer_name">
                            {{data.customer_name}}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.store_name">
                            {{data.store_name}}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.address">
                            {{data.address}}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.phone">
                            {{data.phone}}
                        </template>
                        <template v-else>-</template>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="customerOtherList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getCustomerOtherPage">
            </vue-pagination>
        </div>
        <b-modal hide-footer hide-header ref="setting_fix">
            <div class="text-center">
                <h4>ตั้งค่า ค่าเที่ยวสำหรับลูกค้าย่อย</h4>
                <br>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">
                        <label>ค่า fix</label>
                    </div>
                    <div class="col-sm-5">
                        <input type="number" class="form-control" v-model="setting_fix.fix"/>
                    </div>
                </div>
                <button
                        type="button"
                        @click="saveSettingFix"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button @click="hideSettingFixModal"
                        type="button"
                        class="btn btn-outline-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <b-modal hide-footer hide-header ref="filterTran">
            <div class="text-center">
                <h4>ค่าเที่ยว</h4>
                <br>
                <div class="row form-group">
                    <div class="col-4 text-right">
                        เซลล์
                    </div>
                    <div class="col-6">
                        <multiselect
                                class="form-control select"
                                style="border: none"
                                v-model="search.seller"
                                :options="OptionSeller"
                                :customLabel="customLabel"
                                :show-labels="false"
                                placeholder="ค้นหา Sale"
                                v-if="canSaleOrdersAllView"
                                track-by="sale_id">
                        </multiselect>
                    </div>
                    </div>
                <div class="form-group row">
                    <div class="col-4 text-right">
                        ลูกค้า
                    </div>
                    <div class="col-6">
                        <multiselect
                            class="form-control select"
                            style="border: none"
                            v-model="search.customer"
                            :options="optionCustomer"
                            :customLabel="customerLabel"
                            :show-labels="false"
                            placeholder="ค้นหาลูกค้า"
                            track-by="id">
                        </multiselect>
                </div>
                </div>
                <button
                        type="button"
                        @click="submitTran"
                        class="btn btn-success">
                    ค้นหา
                </button>
                &nbsp&nbsp
                <button @click="hideFilterTranModal"
                        type="button"
                        class="btn btn-outline-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <b-modal hide-footer hide-header ref="filterTrip">
            <div class="text-center">
                <h4>ค่าขนส่ง</h4>
                <br>
                <div class="row form-group">
                    <div class="col-4 text-right">
                        เซลล์
                    </div>
                    <div class="col-6">
                        <multiselect
                                class="form-control select"
                                style="border: none"
                                v-model="search.seller"
                                :options="OptionSeller"
                                :customLabel="customLabel"
                                :show-labels="false"
                                placeholder="ค้นหา Sale"
                                v-if="canSaleOrdersAllView"
                                track-by="sale_id">
                        </multiselect>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-4 text-right">
                        ลูกค้า
                    </div>
                    <div class="col-6">
                        <multiselect
                            class="form-control select"
                            style="border: none"
                            v-model="search.customer"
                            :options="optionCustomer"
                            :customLabel="customerLabel"
                            :show-labels="false"
                            placeholder="ค้นหาลูกค้า"
                            track-by="id">
                        </multiselect>
                    </div>
                </div>
                <button
                        type="button"
                        @click="submitTrip"
                        class="btn btn-success">
                    ค้นหา
                </button>
                &nbsp&nbsp
                <button @click="hideFilterTripModal"
                        type="button"
                        class="btn btn-outline-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <b-modal ref="loading" hide-footer hide-header>
            <loading :status="status_loading" :msg="msg"></loading>
        </b-modal>
<!--        <pre class="alert-primary">{{search}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import VuePagination from "../../Pagination";
    import Multiselect from "vue-multiselect";
    import {
        canSaleOrdersAllView,
    } from "../../../util/Permissions"
    import { domain } from "../../../util/Constants";
    import Loading from "../../Utility/Loading";

    export default {
        components: {Loading, VuePagination,Multiselect},
        name: "customer-other-list",
        created(){
            this.getCustomerOtherPage();
            this.getCustomerAll();
        },
        data(){
          return{
              page : 1,
              customerOtherList : [],
              dataPaginate:{
                  current_page :1,
                  from : 1,
                  last_page : 1,
                  per_page : 1,
                  total : 1,
                  to : 1
              },
              optionCustomer : [],
              status_loading : 1,
              msg : 'กำลังดาวโหลดข้อมูล',
          }
        },
        computed:{
            canSaleOrdersAllView,
            ...mapState({
                setting_fix :state=>{
                    return state.Customer.setting ;
                },
                customer: (state) => {
                    return state.Customer.data;
                },
                search:state =>{
                    return state.Customer.search;
                },
                OptionSeller: state =>{
                    return state.Seller.data;
                },
            }),
        },
        methods:{
            submitTran(){
                let data = {
                    customer : this.search.customer.id ? this.search.customer.id : '',
                    seller : this.search.seller.id ? this.search.seller.id : '',
                };
                this.status_loading = 1;
                this.showLoadingModal();
                this.msg = "กำลังดาวโหลดข้อมูล";
                this.$store.dispatch("Customer/exportTran",data)
                    .then(url=>{
                        window.open(url,'_blank')
                        this.hideLoadingModal();
                    }).catch(err=>{
                    console.log(err);
                    this.showLoadingModal();
                    this.status_loading = 2;
                    this.msg = "ดาวโหลดข้อมูลไม่สำเร็จ";
                });
                this.hideFilterTranModal();
            },
            submitTrip(){
                let data = {
                    customer : this.search.customer.id ? this.search.customer.id : '',
                    seller : this.search.seller.id ? this.search.seller.id : '',
                };
                this.status_loading = 1;
                this.showLoadingModal();
                this.msg = "กำลังดาวโหลดข้อมูล";
                this.$store.dispatch("Customer/exportTrip",data)
                    .then(url=>{
                        window.open(url,'_blank')
                        this.hideLoadingModal();
                    }).catch(err=>{
                        console.log(err);
                        this.showLoadingModal();
                        this.status_loading = 2;
                        this.msg = "ดาวโหลดข้อมูลไม่สำเร็จ";
                });
                this.hideFilterTripModal();
            },
            customerLabel(option){
                return `${option.customer_id} - ${option.store_name}`
            },
            customLabel (option) {
                return `${option.sale_id} - ${option.name}`
            },
            showLoadingModal(){
                this.$refs.loading.show();
            },
            hideLoadingModal(){
                this.$refs.loading.hide();
            },
            showSettingFixModal() {
                this.$refs.setting_fix.show();
            },
            hideSettingFixModal() {
                this.$refs.setting_fix.hide();
            },
            showFilterTranModal() {
                this.clearSearch();
                this.$refs.filterTran.show();
            },
            hideFilterTranModal() {
                this.$refs.filterTran.hide();
            },
            showFilterTripModal() {
                this.clearSearch();
                this.$refs.filterTrip.show();
            },
            hideFilterTripModal() {
                this.$refs.filterTrip.hide();
            },
            getSettingFix(){
                this.showSettingFixModal();
                this.$store.dispatch("Customer/getSettingFix")
            },
            saveSettingFix(){
                this.$store.dispatch("Customer/saveSettingFix",{
                    id : this.setting_fix.id,
                    data : this.setting_fix
                }).then(()=>{
                    this.hideSettingFixModal();
                })
            },
            getCustomerOtherPage(){
                this.page = this.dataPaginate.current_page;
                this.$store.dispatch("Customer/getCustomerOtherList",this.page).then(res=>{
                    this.customerOtherList = res.data;
                    this.dataPaginate = {
                        current_page :res.current_page,
                        from : res.from,
                        last_page : res.last_page,
                        per_page : res.per_page,
                        total : res.total,
                        to : res.to
                    }
                });
            },
            getCustomerAll(){
                this.$store.dispatch("Customer/setAllCustomer").then(res=>{
                    this.optionCustomer = res;
                });
            },
            clearSearch(){
                this.$store.dispatch("Customer/clearSearch");
            }
        }
    }
</script>

<style scoped>

</style>
